/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-extra-boolean-cast */
import React, { useState } from 'react';
import { Typography, Grid, IconButton, Box, Tooltip, CircularProgress } from '@mui/material';
import { makeStyles } from 'utils/makeStylesAdapter';
import CreateIcon from '@mui/icons-material/Create';
import SaveIcon from '@mui/icons-material/Save';
import ClearIcon from '@mui/icons-material/Clear';
import { InputConsensus } from 'components';
import { toast } from 'react-toastify';
import inquiryService from 'services/inquiries/inquiryService';
import organService from 'services/organ/organService';
import { useUserTypes } from 'hooks/useUserTypes';
import { formatNpuMask } from 'masks/masksImask';
import { clearInquiryNumber } from 'utils/genericFunctions/formatedInquiryNumber';
import PmService from 'services/PM/pmService';
import LazyAutocomplete from '../LazyAutocomplete';
import { useParameterKeys } from 'hooks/useParameterKeys';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  titulo: {
    color: '#00597b',
    fontWeight: 'bold',
    textAlign: 'left',
    fontSize: 20,
    fontFamily: 'roboto-regular',
  },
  containerJudicial: {
    marginTop: theme.spacing(1),
  },
  boxLeft: {
    textAlign: 'left',
    paddingLeft: theme.spacing(1.5),
  },
  boxRight: {
    textAlign: 'left',
    paddingRight: theme.spacing(1.5),
  },
  labelTitle: {
    color: '#00597b',
  },
  inputResult: {
    color: '#00597b',
    fontWeight: 'bold',
  },
}));

const JudicialInformations = props => {
  const {
    inquiry,
    refreshPage,
    write = false,
    otherStep = false,
    setRefreshTasks,
    canEdit = false,
  } = props;

  const { isPM } = useUserTypes();

  const { isMPDFT } = useParameterKeys();

  const classes = useStyles();

  const [editJudicial, setEditJudicial] = useState(false);

  const initialValues = {
    npu: inquiry.npu,
    judgmentPlace: inquiry.judgmentPlace,
  };

  const [formState, setFormState] = useState({
    values: { ...initialValues },
  });

  const handleChange = event => {
    const { target } = event;
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [target.name]: clearInquiryNumber(target.value).slice(0, 20),
      },
    }));
  };

  const fetchDelegacias = async (search, page) => {
    const params = {
      page,
      size: 20,
      search,
      category: 'JUDICIARY',
    }

    const result = await organService.getDelegaciasService(params);

    return {
      data: result.data.data,
      lastPage: result.data.lastPage,
    }
  }

  const handleChangeJudgmentPlace = (_event, newValue) => {
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        judgmentPlace: newValue,
      },
    }));
  };

  const editJuficialInformations = () => {
    const { npu, judgmentPlace } = formState.values;

    let params = {};

    if (npu && !isMPDFT) {
      if (npu.length < 20) {
        toast.warn('NPU inválido. Verifique se o NPU digitado contém 20 números');
        return;
      }

      params.npu = npu;
    } else {
      params.npu = null;
    }

    if (judgmentPlace) {
      params.judgmentPlaceId = judgmentPlace.id;
    } else {
      params.judgmentPlaceId = null;
    }
    if (isPM) {
      PmService.updateInquiryInvestigatedService(inquiry.id, params).then(() => {
        toast.success('Informações alteradas com sucesso');
        setEditJudicial(false);
        if (inquiry.step === 'TRAMITACAO_CONTROLE') {
          setRefreshTasks(true);
        }
        refreshPage();
      });
    } else {
      inquiryService.updateInquiryInvestigatedService(inquiry.id, params).then(() => {
        toast.success('Informações alteradas com sucesso');
        setEditJudicial(false);
        if (inquiry.step === 'TRAMITACAO_CONTROLE') {
          setRefreshTasks(true);
        }
        refreshPage();
      });
    }
  };

  const handleEditJudicial = () => {
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        judgmentPlace: inquiry.judgmentPlace,
        npu: inquiry.npu,
      },
    }));
    setEditJudicial(true);
  };

  const handleEditJudicialToFalse = () => {
    setEditJudicial(false);
  };

  const handleUpdateJudicial = () => {
    editJuficialInformations();
  };

  const handleOpenSnackbar = (message = 'Você não tem permissão para tomar esta ação.') => {
    return toast.warn(message);
  };

  return (
    <Box className={classes.root}>
      <Box display="flex" justifyContent="space-between" alignItems="center" p={1.5}>
        <Box>
          <Typography className={classes.titulo}>Dados da Justiça</Typography>
        </Box>
        <Box display="flex" justifyContent="flex-end" alignItems="center">
          {!editJudicial && ((!otherStep && !isPM) || canEdit) ? (
            <Tooltip title="Alterar dados" arrow placement="top">
              <IconButton
                size="small"
                onClick={() => (!write ? handleOpenSnackbar() : handleEditJudicial())}
              >
                <CreateIcon style={{ color: '#00b1ac' }} />
              </IconButton>
            </Tooltip>
          ) : (
            editJudicial && (
              <>
                <Box style={{ marginRight: 10 }}>
                  <Tooltip title="Salvar alterações" arrow placement="top">
                    <IconButton
                      size="small"
                      onClick={handleUpdateJudicial}
                      form="my-form-edit"
                      type="submit"
                    >
                      <SaveIcon style={{ color: '#1976d2' }} />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Box>
                  <Tooltip title="Cancelar" arrow placement="top">
                    <IconButton size="small" onClick={handleEditJudicialToFalse}>
                      <ClearIcon style={{ color: '#e1296a' }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              </>
            )
          )}
        </Box>
      </Box>
      <Grid container spacing={2} className={classes.containerJudicial}>
        {!isMPDFT && (
          <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }}>
            <Box className={classes.boxLeft}>
              {!editJudicial ? (
                <>
                  <Typography className={classes.labelTitle} component="label" variant="body2">
                    NPU
                  </Typography>
                  <Typography className={classes.inputResult} variant="body1">
                    {inquiry.npu ? formatNpuMask(inquiry.npu) : 'não informado'}
                  </Typography>
                </>
              ) : (
                <InputConsensus
                  onChange={handleChange}
                  value={formState?.values?.npu ? formatNpuMask(formState.values.npu) : ''}
                  label="NPU"
                  name="npu"
                  variant="standard"
                  fullWidth
                />
              )}
            </Box>
          </Grid>
        )}
        <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }}>
          <Box className={classes.boxRight}>
            {!editJudicial ? (
              <>
                <Typography className={classes.labelTitle} component="label" variant="body2">
                  Vara/Local
                </Typography>
                <Typography className={classes.inputResult} variant="body1">
                  {inquiry.judgmentPlace?.name || 'não informado'}
                </Typography>
              </>
            ) : (
              <LazyAutocomplete
                value={formState.values.judgmentPlace}
                onChange={handleChangeJudgmentPlace}
                getOptionLabel={option => option?.name || ''}
                enablePagination
                fetchOptions={fetchDelegacias}
                renderInput={params => (
                  <InputConsensus
                    {...params}
                    label="Vara/Local"
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {params.InputProps.loading ? (
                            <CircularProgress color="primary" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default JudicialInformations;
